import React from "react";

import { Segmented } from "../../../components/ui";
import {
  DEFAULT_PRICE_CHART_RANGE,
  PRICE_CHART_RANGE_OPTIONS,
} from "./priceChartUtils";

const OPTIONS = PRICE_CHART_RANGE_OPTIONS.map(({ id, label }) => ({ value: id, label }));

const PriceChartRangeFilters = ({
  value = DEFAULT_PRICE_CHART_RANGE,
  onChange,
}) => (
  <Segmented
    size="sm"
    label="Price chart date range"
    data-btn="price-range-filter"
    options={OPTIONS}
    value={value}
    onChange={onChange}
  />
);

export default PriceChartRangeFilters;
